import { apiClient } from './client'

export type InteractionSourceType = 'ARTICLE' | 'AI_PRACTICE'

export type EngagementType =
  | 'DWELL'
  | 'SENSE_EXPLORED'
  | 'AUDIO_PLAYED'
  | 'ADDED_TO_VOCAB'
  | 'PHRASE_POPUP_SHOWN'
  | 'PHRASE_ADD_INTENT'

export interface RecordLanguageInteractionPayload {
  selection: string
  context?: string
  sourceType: InteractionSourceType
  articleId?: string
  engagementType: EngagementType
  clientSessionId: string
}

export const interactionsApi = {
  record: (payload: RecordLanguageInteractionPayload) =>
    apiClient.post<void>('/language-interactions', payload),
}
